import React from 'react';
import { CheckmarkCircleOutline } from 'react-ionicons';

import { FILLS, TYPE } from '../../styles/tokens';
import { PASSWORD_HINT, isPasswordLongEnough } from '../../utils/authFormValidation';

interface NewPasswordHintProps {
  /** Id the password input points at with aria-describedby. */
  id: string;
  password: string;
}

const NewPasswordHint: React.FC<NewPasswordHintProps> = ({ id, password }) => {
  const isMet = isPasswordLongEnough(password);
  return (
    <span
      id={id}
      style={{
        ...TYPE.finePrint,
        color: isMet ? FILLS.success : FILLS.textMuted,
        marginTop: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      {isMet && (
        <span aria-hidden="true" data-testid="password-hint-check" style={{ display: 'flex' }}>
          <CheckmarkCircleOutline color={FILLS.success} width="14px" height="14px" />
        </span>
      )}
      {PASSWORD_HINT}
    </span>
  );
};

export default NewPasswordHint;
